import { render, staticRenderFns } from "./AppToasts.vue?vue&type=template&id=0dcba8a4&"
import script from "./AppToasts.vue?vue&type=script&lang=js&"
export * from "./AppToasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports